import { useQuery } from '@tanstack/react-query'

import { apiGetServiceAreaAvailability } from '@/apis/serviceArea/getServiceAreaAvailability'

import { SERVICE_AREA_KEYS } from '../keys/serviceArea'

interface UseGetServiceAreaAvailabilityParams {
  /** 검증할 주소 — null/빈값이면 쿼리 비활성 */
  address: string | null
}

/**
 * 서비스 지역 여부 검증 훅 — 1차 검증 (주소 클릭 직후 자동).
 *
 * 200 + isAvailable boolean 응답으로 분기. user-context 에러(미납·이미 신청)
 * 는 이 API 에 안 옴 — 2차 검증(/orders/availability)에서 차단.
 *
 * staleTime 짧게 (60s): 백엔드 service_area 데이터 갱신 가능성.
 * retry false: 에러 시 즉시 onError 분기.
 */
export const useGetServiceAreaAvailability = ({ address }: UseGetServiceAreaAvailabilityParams) => {
  return useQuery({
    queryKey: [SERVICE_AREA_KEYS.AVAILABILITY, address],
    queryFn: () => apiGetServiceAreaAvailability({ address: address! }),
    enabled: !!address,
    staleTime: 60 * 1000,
    retry: false,
  })
}
